module.exports = __webpack_public_path__ + "static/10-8a16cfc78c516f13e233fb7531703083.png";